import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { getAffirmConfig } from '../components/paymentOptions/Affirm/affirmConfig';
import { loadAffirm } from '../components/paymentOptions/Affirm/loadAffirm';

// Loads Affirm.js when the session advertises Affirm and reports readiness.
// Consumers must not touch affirm.* until `ready` is true.
export const useAffirm = () => {
  const sessionDetails = useSelector((state) => state.paymentSessionDetails.sessionDetails);
  const { publicApiKey } = getAffirmConfig(sessionDetails);

  const affirmRef = useRef(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!publicApiKey) return undefined;

    let cancelled = false;
    loadAffirm(sessionDetails)
      .then((affirm) => {
        if (cancelled) return;
        affirmRef.current = affirm;
        setReady(true);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      });

    return () => { cancelled = true; };
  }, [publicApiKey, sessionDetails]);

  return { affirm: affirmRef.current, ready, error };
};
